module.exports = __webpack_public_path__ + "img/ug532.527bfe73.png";